export const BAND_NAMES = ['0–25 mi', '26–50 mi', '51–100 mi', '101–200 mi', '201–250 mi', '251+ mi'];
export const TARGETS = [
  ['delivered', 'Delivered PROs / day', 'count', 'Terminal'],
  ['loads_per_truck', 'Loads / truck / day', 'number', 'Terminal'],
  ['driver_pay', 'Driver pay / day', 'money', 'Terminal'],
  ['otd', 'On-time delivery', 'percent', 'Terminal'],
  ['start_minutes', 'Average driver start', 'time', 'Terminal'],
  ['missed_loads', 'Maximum missed loads / day', 'count', 'Terminal'],
  ['sent_to_cs', 'Paid-not-billed sent to CS', 'percent', 'Terminal'],
  ['turndowns', 'Maximum turndowns / day', 'count', 'Customer Service'],
  ['same_day_billing', 'Items billed same day', 'percent', 'Customer Service'],
  ['email_minutes', 'First email response (minutes)', 'number', 'Customer Service'],
  ['weekend_loads', 'Weekend loads / day', 'count', 'Customer Service'],
  ['weekend_offered', 'Weekend option offered', 'percent', 'Customer Service'],
  ['backlog_over_7', 'Maximum backlog over 7 days', 'money', 'Customer Service'],
  ['accessorial_recovery', 'Accessorials billed ÷ paid', 'percent', 'Customer Service'],
  ['margin', 'Margin', 'percent', 'Revenue / Costs'],
  ['unbilled_exposure', 'Maximum unbilled exposure', 'money', 'Revenue / Costs'],
] as const;
export type TargetKey = typeof TARGETS[number][0];
export type Band = { mix: number; booking_percent: number; loads_per_truck: number; pay_per_load: number };
export type Plan = { id?: number; region: string; name: string; start: string; end: string; targets: Partial<Record<TargetKey, number | null>>; weekday_delivered: (number | null)[]; bands: Band[]; notes: string; created_by?: string; created_at?: string };
export const newPlan = (region: string, start: string, end: string): Plan => ({ region, name: '', start, end, targets: { driver_pay: 1100 }, weekday_delivered: Array(7).fill(null), bands: [], notes: '' });
export function planForRange(plans: Plan[], start: string, end: string) {
  return plans.find(p => p.start <= start && p.end >= end);
}
export function dayCount(start: string, end: string) {
  return Math.floor((Date.parse(`${end}T00:00:00Z`) - Date.parse(`${start}T00:00:00Z`)) / 86400000) + 1;
}
export function deliveryTarget(plan: Plan, start: string, end: string): number | null {
  let sum = 0;
  for (let d = Date.parse(`${start}T00:00:00Z`); d <= Date.parse(`${end}T00:00:00Z`); d += 86400000) {
    const goal = plan.weekday_delivered[(new Date(d).getUTCDay() + 6) % 7] ?? plan.targets.delivered;
    if (goal == null) return null;
    sum += goal;
  }
  return sum;
}
export function bandProjection(plan: Plan) {
  const daily = plan.targets.delivered;
  if (daily == null || plan.bands.length !== 6 || Math.abs(plan.bands.reduce((s,b) => s+b.mix,0)-100) > .001) return [];
  const raw = plan.bands.map(b => daily*b.mix/100);
  const goals = raw.map(Math.floor);
  const rank = raw.map((n,i) => ({ i, fraction: n-goals[i] })).sort((a,b) => b.fraction-a.fraction);
  for (let left = Math.round(daily)-goals.reduce((s,n)=>s+n,0), i=0; i<left; i++) goals[rank[i].i]++;
  return plan.bands.map((b,i) => {
    const drivers = Math.ceil(goals[i]/b.loads_per_truck);
    return { name: BAND_NAMES[i], goal: goals[i], booked: Math.ceil(goals[i]*b.booking_percent/100), drivers,
      pay: drivers ? goals[i]*b.pay_per_load/drivers : 0, totalPay: goals[i]*b.pay_per_load };
  });
}
export const LOWER_BETTER = new Set<TargetKey>(['start_minutes','missed_loads','turndowns','email_minutes','unbilled_exposure','backlog_over_7']);
export function progressStatus(actual: number | null, target: number | null, lower: boolean, inProgress: boolean) {
  if (actual == null) return 'Not connected';
  if (target == null) return 'No target';
  if (lower ? actual <= target : actual >= target) return 'At target';
  return inProgress ? 'In progress' : 'Below target';
}
